import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const NavigationBarTasksWhite = (props) => (<Svg width={props.width || '100%'} height={props.height || '100%'} viewBox="0 0 16 16" fill="none" {...props}>
    <Rect width={12.8} height={12.8} x={1.6} y={1.6} fill="#fff" rx={1.846}/>
    <Path stroke="#0B1F2C" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.333} d="M6.18 7.385 8.024 9.23l6.154-6.154"/>
  </Svg>);
export default NavigationBarTasksWhite;
